import CreateCourseBasicDetailsPage from './CreateCourseBasicDetailsPage';
import { CreateCourseBasicDetailsPageProps, CreateCourseBasicDetailsPageValueProps } from './types';

export type { CreateCourseBasicDetailsPageProps, CreateCourseBasicDetailsPageValueProps };
export default CreateCourseBasicDetailsPage;
